import React from 'react';
import { Grid, TextField } from '@material-ui/core';
import { Dialog } from 'components';
import { Autocomplete } from '@material-ui/lab';
import DateField from 'components/DateField';
import { editLeaveData } from 'store/firebase';
import { useAlert, useReduxDispatch } from 'store/hooks';
import moment from 'moment';
import { fetchPendingRequests } from 'store/pendingRequest';

const EditAppealDialog = ({ draftEditLeave, selectedLeave, setAction, onChangeDraftEditLeave }) => {
  const { alertWaiting, alertSuccess, alertError } = useAlert();
  const getPendingRequest = useReduxDispatch(fetchPendingRequests);

  const onChangeStatus = (key, value) => {
    if (value === 'rejected') {
      onChangeDraftEditLeave({ ...selectedLeave, status: value });
    } else {
      if (key === 'startTime' && +draftEditLeave.type === 26) {
        onChangeDraftEditLeave({
          ...draftEditLeave,
          ...{
            startTime: value,
            endTime: moment(new Date(value)).add(90, 'days').valueOf(),
          },
        });
      } else {
        onChangeDraftEditLeave({ ...draftEditLeave, [key]: value });
      }
    }
  };

  const submitEditLeave = () => {
    if (!draftEditLeave.changeStatusMessage || draftEditLeave.changeStatusMessage === '') {
      alertError('Silahkan mengisi alasan perubahan terlebih dahulu');
      return;
    }

    if (draftEditLeave.status === '') {
      alertError('Silahkan Pilih status terlebih dahulu');
      return;
    }

    if (draftEditLeave.startTime > draftEditLeave.endTime) {
      alertError('Tanggal akhir Cuti kurang dari Tanggal Mulai cuti');
      return;
    }

    alertWaiting();
    editLeaveData(draftEditLeave)
      .then(() => {
        alertSuccess();
        onChangeDraftEditLeave();
        getPendingRequest();
        setAction();
      })
      .catch((error) => {
        alertError(error?.message);
      });
  };

  return (
    <Dialog
      fullWidth
      title="Ubah Cuti"
      open={!!draftEditLeave}
      onClose={() => onChangeDraftEditLeave()}
      action={{
        label: 'Simpan Perubahan',
        onClick: submitEditLeave,
      }}
    >
      <Grid
        container
        spacing={3}
        style={{
          marginBottom: '20px',
        }}
      >
        <Grid item sm={6}>
          <TextField
            fullWidth
            label="NIP"
            InputLabelProps={{
              shrink: true,
            }}
            value={draftEditLeave?.employee?.nip}
            style={{
              marginBottom: '16px',
            }}
          />
        </Grid>
        <Grid item sm={6}>
          <TextField
            fullWidth
            label="Nama"
            InputLabelProps={{
              shrink: true,
            }}
            value={draftEditLeave?.employee?.fullname}
            style={{
              marginBottom: '16px',
            }}
          />
        </Grid>
        <Grid item sm={6}>
          <DateField
            disabled={draftEditLeave?.status === 'rejected'}
            label="Tanggal Mulai"
            value={draftEditLeave?.startTime}
            onChange={(value) => onChangeStatus('startTime', value)}
            style={{
              marginBottom: '16px',
            }}
          />
        </Grid>
        <Grid item sm={6}>
          <DateField
            disabled={
              draftEditLeave?.category !== 'leave' ||
              draftEditLeave?.status === 'rejected' ||
              +draftEditLeave.type === 26
            }
            minDate={draftEditLeave?.startTime}
            label="Tanggal Akhir"
            value={draftEditLeave?.endTime}
            onChange={(value) => onChangeStatus('endTime', value)}
            style={{
              marginBottom: '16px',
            }}
          />
        </Grid>
        <Grid item sm={12}>
          <Autocomplete
            options={['Terima', 'Tolak']}
            defaultValue={draftEditLeave?.status === 'approved' ? 'Terima' : 'Tolak'}
            onChange={(_, value) =>
              onChangeStatus(
                'status',
                value === 'Terima' ? 'approved' : value === 'Tolak' ? 'rejected' : ''
              )
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Status Pengajuan"
                variant="standard"
                style={{
                  marginBottom: 16,
                }}
                error={draftEditLeave?.status === ''}
                helperText={draftEditLeave?.status === '' ? 'Silahkan pilih status pengajuan' : ' '}
              />
            )}
          />
        </Grid>
        <Grid item sm={12}>
          <TextField
            fullWidth
            label="Alasan Perubahan"
            InputLabelProps={{
              shrink: true,
            }}
            value={draftEditLeave?.changeStatusMessage}
            onChange={({ target: { value } }) => onChangeStatus('changeStatusMessage', value)}
          />
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default EditAppealDialog;
